import "@/js/bootstrap/legacy-base.js";
import KTCookie from "@/js/components/cookie.js";
import KTDialer from "@/js/components/dialer.js";
import KTDrawer from "@/js/components/drawer.js";
import KTFeedback from "@/js/components/feedback.js";
import KTImageInput from "@/js/components/image-input.js";
import KTMenu from "@/js/components/menu.js";
import KTPasswordMeter from "@/js/components/password-meter.js";
import KTPlace from "@/js/components/place.js";
import KTScroll from "@/js/components/scroll.js";
import KTScrolltop from "@/js/components/scrolltop.js";
import KTSearch from "@/js/components/search.js";
import KTStepper from "@/js/components/stepper.js";
import KTSticky from "@/js/components/sticky.js";
import KTToggle from "@/js/components/toggle.js";
import KTLayoutAside from "@/js/layout/aside.js";
import KTLayoutSearch from "@/js/layout/search.js";
import KTLayoutToolbar from "@/js/layout/toolbar.js";
import KTApp from "@/js/layout/app.js";
window.KTUtil = window.KTUtil;
window.KTCookie = KTCookie;
window.KTDialer = KTDialer;
window.KTDrawer = KTDrawer;
window.KTEventHandler = window.KTEventHandler;
window.KTFeedback = KTFeedback;
window.KTImage = KTImageInput;
window.KTMenu = KTMenu;
window.KTPasswordMeter = KTPasswordMeter;
window.KTPlace = KTPlace;
window.KTScroll = KTScroll;
window.KTScrolltop = KTScrolltop;
window.KTSearch = KTSearch;
window.KTStepper = KTStepper;
window.KTSticky = KTSticky;
window.KTToggle = KTToggle;

// Layout
window.KTLayoutAside = KTLayoutAside;
window.KTLayoutSearch = KTLayoutSearch;
window.KTLayoutToolbar = KTLayoutToolbar;
window.KTApp = KTApp;

window.initializeKT = function () {
    setTimeout(function () {
        window.KTUtil.init();
        window.KTDialer.init();
        window.KTToggle.init();
        window.KTLayoutAside.init();
        window.KTDrawer.init();
        window.KTPlace.init();
        window.KTScroll.init();
        window.KTScrolltop.init();
        window.KTImage.init();
        window.KTSticky.init();
        window.KTApp.init();
        window.KTMenu.init();
    }, 500);
}
